import { useState, useEffect } from "react";
import { FavComponent } from "../../components/Favorites/FavComponent";
import { HistoryComponent } from "../../components/History/HistoryComponent";
import styles from "./TabLayout.module.css";

interface props {
    menuOpen: Function;
}

export const TabLayout = (propsData: props) => {
    const [tabValue, setTabValue] = useState<string>("Favoritos");
    // useEffect(() => {
    //     if (tabValue === "Favoritos") {
    //         document.getElementById("title-fav")?.classList.add("titleClicked");
    //         document.getElementById("title-hist")?.classList.remove("titleClicked");
    //     } else if (tabValue === "Historial") {
    //         document.getElementById("title-hist")?.classList.add("titleClicked");
    //         document.getElementById("title-fav")?.classList.remove("titleClicked");
    //     }
    // }, [tabValue]);

    function className(value: string) {
        if (tabValue === value) {
            return `${styles.title} ${styles.titleClicked}`;
        } else {
            return `${styles.title}`;
        }
    }
    return (
        <div className={styles.container}>
            <div className={styles.titlesBlock}>
                <span
                    id="title-fav"
                    className={className("Favoritos")}
                    onClick={() => {
                        setTabValue("Favoritos");
                    }}
                >
                    Favoritos
                </span>
                {
                    <span
                        id="title-hist"
                        className={className("Historial")}
                        onClick={() => {
                            setTabValue("Historial");
                        }}
                    >
                        Historial
                    </span>
                }
            </div>
            {tabValue === "Favoritos" && <FavComponent menuOpen={propsData.menuOpen} />}
            {tabValue === "Historial" && <HistoryComponent menuOpen={propsData.menuOpen} />}
        </div>
    );
};
